export const SUMMARY_TEXTS_LIST = [
  ['Проверяем застройщиков', 'Здороваемся с соседями', 'Всё почти готово'],
  ['Замеряем высоту потолков', 'Гуляем по дворам', 'Уточняем информацию'],
  ['Считаем квартиры на этаже', 'Качаемся на качелях', 'Готовим выводы'],
  ['Изучаем район', 'Любуемся закатом с балкона', 'Остались последние штрихи'],
  ['Присматриваемся к ЖК', 'Ищем булочную рядом', 'Подводим итоги'],
  ['Ищем ЖК на карте', 'Знакомимся с консьержем', 'Сейчас всё покажем'],
];

export function randomSummaryTextList() {
  return SUMMARY_TEXTS_LIST[Math.floor(Math.random() * SUMMARY_TEXTS_LIST.length)];
}
